module.exports = __webpack_public_path__ + "static/media/SFicon.aaa94ea5.svg";